var config = {
  address: 'https://api.adwayusa.com',
  stripePaymentLink: 'https://connect.stripe.com/express/oauth/authorize?redirect_url=https://stripe.adwayusa.com/stripe_callback.php&client_id=',
  admin_header: [
    {
      img: './../../assets/dashboard.svg',
      name: 'Dashboard'
    },
    {
      img: './../../assets/createcampain.png',
      name: 'Create Campaign'
    },
    {
      img: './../../assets/finance.png',
      name: 'Finance'
    },
    {
      img: './../../assets/account.svg',
      name: 'Account'
    },
    {
      img: './../../assets/contactus.png',
      name: 'Contact Us'
    },
    {
      img: './../../assets/aboutus.svg',
      name: 'About Us'
    },
    {
      img: '',
      name: 'Log Out'
    }
  ]
}

export default config
